import jQuery from "jquery";
const $ = jQuery;
export default class Header {
    constructor() {
        this.setDomMap();
        this.domManipulate();
        this.bindEvents();
        this.reflow();
    }


    setDomMap = () => {
        this.html = $('html');
        this.window = $(window);
        this.siteOverlay = $('.site-overlay');
        this.body = this.html.find('body');
        this.header = $('header');
        this.navTopLvItems = this.header.find('.nav-menu > li');
        this.subLvItems = this.navTopLvItems.find('.lv-1 li');
        this.featuredProducts = this.header.find('.wrap > .featuring-products');
        this.sideMenu = $('.slide-menu');
        this.slideTopLv = this.sideMenu.find('.menu-items li.menu-item-has-children');
        this.slideMenuSlider = this.sideMenu.find('.swiper');
    }

    domManipulate = () => {
        this.featuredProducts.each(function (i, el) {
            $(el).parents('.mega-menu').addClass('three-quarter');
        })
    }

    reflow = () => {
        const flow = (() => {
            const width = this.window.width();
            this.body.width(width);
            this.header.width(width);
            this.menuSliderAjust(0, true)
        })
        flow();

        this.window.on('resize', function () {
            flow();
        })
    }

    menuSliderAjust = (item, resize) => {
        const parentWidth = $(this.slideTopLv).innerWidth() - 42;
        if (item && item.length > 0) {
            $(item).addClass('opacity-0');
            $(item).width('0');
            setTimeout(() => {

                $(item).width(parentWidth + 'px');
                $(item).removeClass('opacity-0');
            }, 500);
        }

        if (resize) {
            this.slideMenuSlider.each((i, el) => {
                $(el).addClass('opacity-0');
                $(el).width('0');
                setTimeout(() => {

                    $(el).width(parentWidth + 'px');
                    $(el).removeClass('opacity-0');
                }, 500);
            })
        }
    }


    /* setcookie = (cname, cvalue, exdays) => {
        const d = new Date();
        d.setTime(d.getTime() + (exdays * 3600000 * 24));
        let expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    } */

    menuInteraction = () => {
        let megaMenuEntryTimeIn, megaMenuEntryTimeOut;
        this.navTopLvItems.on({
            'mouseover': (el) => {
                $(el.currentTarget).find('.mega-menu').show();
                clearTimeout(megaMenuEntryTimeOut);
                const target = el.currentTarget;
                $(el.currentTarget).removeClass('in-active');
                megaMenuEntryTimeIn = setTimeout(() => {
                    if (!$(target).hasClass('active-menu-item')) {
                        // this.navTopLvItems.removeClass('active-menu-item');
                        this.html.addClass('overflow-hidden');
                        this.body.addClass('overflow-hidden');
                        $(target).addClass('active-menu-item');
                        this.siteOverlay.addClass('menu-active');
                    }
                }, 200);
            },
            'mouseleave': (el) => {
                this.body.addClass('');
                $(el.currentTarget).find('.mega-menu').hide();
                this.navTopLvItems.removeClass('active-menu-item');
                $(el.currentTarget).addClass('in-active');
                clearTimeout(megaMenuEntryTimeIn);

                megaMenuEntryTimeOut = setTimeout(() => {
                    const target = el.currentTarget;
                    $(target).removeClass('active-menu-item');
                    this.html.removeClass('overflow-hidden');
                    this.body.removeClass('overflow-hidden');
                    this.siteOverlay.removeClass('menu-active');
                    $(target).find('.mega-menu').show();
                    $(target).removeClass('in-active');
                }, 300);
            }
        })
        this.subLvItems.on({
            'mouseover': (el) => {
                const target = el.currentTarget;
                const id = $(target).attr('data-menu-id');
                if ($(target).not('.active-sub-item')) {
                    $(target).parent().find('.active-sub-item').removeClass('active-sub-item');
                    $(`#${id}`).parent().find('.active-overview').removeClass('active-overview');

                    $(target).addClass('active-sub-item');
                    $(`#${id}`).addClass('active-overview');
                }
            }
        })

        this.slideTopLv.find('a').on('click', (el) => {
            const target = el.currentTarget;
            if ($(target).parent('.menu-item-has-children').length || $(target).parent('.has-children').length) {
                el.preventDefault();
                const slider = $(target).next().find('.swiper')
                $(target).next().slideToggle();
                $(target).parent().toggleClass('active-menu-item');
                this.menuSliderAjust(slider, false)
            }
        })

        this.menuSliderAjust();
    }

    bindEvents = () => {
        this.window.on('load', this.onLoad);
        this.browserScroll();
        this.menuInteraction();
    }

    browserScroll = () => {
        let lastScrollTop = 0;
        const header = document.querySelector('header');
        const tocInside = document.querySelector('.toc-inside-content');
        const tocFloating = document.querySelector('.toc-floating-right-box');

        window.addEventListener('scroll', function () {
            let current = window.scrollY;
            //(current > 150 && current > lastScrollTop) ? header.classList.add('slide-up'): header.classList.remove('slide-up');
            (current > 200) ? header.classList.add('sticky') : header.classList.remove('sticky');

            if (tocInside != null) {
                const innerHeight = tocInside.clientHeight;
                const totalOffset = tocInside.getBoundingClientRect().bottom;
                if (totalOffset <= 0) {
                    tocFloating.classList.add('active')
                } else if (tocFloating.classList.contains('active')) {
                    tocFloating.classList.remove('active')
                }
            }

            lastScrollTop = current;
        });
    }

}